module.exports = __webpack_public_path__ + "media/images/writer/community/pc-headline-about-maker@3x-e95150448884257340be2e0dfa5b28f9.png";